import React from "react";

// Renders UMoooV's markdown-lite section format:
//   - blank line separates blocks
//   - "### " = sub-heading
//   - lines starting with "- " = bullet list
//   - **text** = bold
const renderBold = (text) =>
  text.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? (
      <strong key={i} className="font-semibold">{part.slice(2, -2)}</strong>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );

// Render a group of non-heading lines as either a bullet list or a paragraph.
const renderBody = (lines, key, listClass, paraClass) => {
  const clean = lines.filter((l) => l.trim() !== "");
  if (clean.length === 0) return null;
  if (clean.every((l) => l.trim().startsWith("- "))) {
    return (
      <ul key={key} className={`list-disc pl-5 space-y-1.5 mb-5 ${listClass}`}>
        {clean.map((l, li) => (
          <li key={li}>{renderBold(l.trim().slice(2))}</li>
        ))}
      </ul>
    );
  }
  return (
    <p key={key} className={`mb-5 ${paraClass}`}>
      {renderBold(clean.join(" "))}
    </p>
  );
};

export const RichText = ({ text, headingClass = "", listClass = "", paraClass = "" }) => {
  if (!text) return null;
  const blocks = text.split(/\n\n+/);
  const out = [];
  blocks.forEach((block, bi) => {
    const lines = block.split("\n");
    if (lines[0].startsWith("### ")) {
      out.push(
        <h4 key={`h-${bi}`} className={`font-sans font-semibold mt-6 mb-2 ${headingClass}`}>
          {renderBold(lines[0].slice(4))}
        </h4>
      );
      const rest = renderBody(lines.slice(1), `b-${bi}`, listClass, paraClass);
      if (rest) out.push(rest);
    } else {
      const body = renderBody(lines, `b-${bi}`, listClass, paraClass);
      if (body) out.push(body);
    }
  });
  return <>{out}</>;
};

export default RichText;
